import React from "react";

const FAQMarketing = ({ faqs }) => {
  return (
    <div className=" my-5 text-oscuro">
      <h2 className="text-2xl text-center sm:text-left sm:text-3xl text-lyellow sm:pl-[2.2em] mb-10 font-semibold">
        Frequently Asked Questions
      </h2>
      <div className="flex flex-col justify-center w-full">
        <div className="flex justify-center items-center flex-col w-3/4 sm:w-6/12 mx-auto mb-5">
          {faqs.map((faq, index) => {
            return (
              <div key={index} className="relative  border border-black/50">
                <input type="checkbox" id={`toggle${index}`} className="toggle hidden" />
                <label
                  className="title block font-bold bg-black/40 p-4 cursor-pointer"
                  for={`toggle${index}`}
                >
                  {faq.question}
                </label>
                <div className="content bg-[#2a313700] overflow-hidden">
                  <p className="p-4">
                    {faq.answer}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};

export default FAQMarketing;
